import {
  TextField,
  MenuItem,
  StandardTextFieldProps,
  FilledTextFieldProps,
  OutlinedTextFieldProps,
} from '@mui/material';
import { forwardRef, ReactElement, Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { lang } from '../utils/lang';

interface StandardProps extends StandardTextFieldProps {}

interface FilledProps extends FilledTextFieldProps {}

interface OutlinedProps extends OutlinedTextFieldProps {}

type LangProps = StandardProps | FilledProps | OutlinedProps;

function LangComponent({ ...rest }: LangProps, ref: Ref<HTMLDivElement>): ReactElement {
  const { t } = useTranslation();

  return (
    <TextField
      ref={ref}
      {...rest}
      select
      // sx={{borderRadius: '20px'}}
    >
      {lang.map((el) => (
        <MenuItem value={el.id} key={el.id}>
          <img src={el.img} width={20} alt={t(el.label)} style={{ marginRight: '20px' }} />
          {/* {t(el.label)} */}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default forwardRef<HTMLDivElement, LangProps>(LangComponent);
